/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hydraulic_Coil_AssociationInputs */



/**
* | output |
* | --- |
* | "Hydraulic coil association" |
*
* @param {Hydraulic_Coil_AssociationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const hydraulic_coil_association = /** @type {((inputs?: Hydraulic_Coil_AssociationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hydraulic_Coil_AssociationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Hydraulic coil association")
	return /** @type {LocalizedString} */ ("Gestion des batteries hydrauliques")
});